/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    enum Roles {
        MiddleSchool = 1 << 0, // 1
        HighSchool = 1 << 1, // 2
        College = 1 << 2, // 4
        AdultLearner = 1 << 3, // 8
        Parent = 1 << 4, // 16
        EducationProfessional = 1 << 5, // 32
        NC529AccountHolder = 1 << 6, // 64
        EducationLoanBorrower = 1 << 7 // 128
    };

    class UserProfile implements IUserProfile {
        addressVerified: boolean;
        associatedSchools: Array<ICustomerViewModel>;
        comments: Array<any>;
        customer: ICustomerViewModel;
        dateOfBirth: string;
        daytimePhone: string;
        email: string;
        enrollmentStatus: number;
        eveningPhone: string;
        firstName: string;
        fromServer: boolean;
        gender: number;
        graduationYear: number;
        id: number;
        lastName: string;
        mailAddress: IAddress;
        mailingPhone: string;
        middleName: string;
        nickname: string;
        permAddress: IAddress;
        phoneNumber: string;
        primaryConnectionCrmId: number;
        role: any;
        socialSecurityNumber: string;
        studentId: string;
        suffix: string;
        userContactInfo: any;
        username: string;
        mobilePhone: string;
        homePhone: string;
        workPhone: string;
        emailInvalid: boolean;
        addressInvalid: boolean;
        phoneNumberInvalid: boolean;
        passwordInvalid: boolean;
        textingOptIns: ITextingOptIns;
        emailIsValid: boolean;
        emailVerified: boolean;
        emailSignature: string;
        tin: string;
    }


    class NextStepsLandingPage{
        static controllerId: string = "nextStepsLandingPage";
        static $inject: Array<string> = ["common", "config", "Restangular", "$location"];
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;

        
        formCompleted: boolean = false;
        userProgress: any;
        loading: boolean;
        user: UserProfile;
        convertedRoles: Array<any>;
        roles: Array<any>;
        isEducatorRole: boolean;


        constructor(private common: ICommonFactory,
            private config: IConfig,
            private Restangular: Restangular.IService,
            private $location: ng.ILocationService
        ) {       
            this.loading = true;
            this.log = common.logger.getLogFn(NextStepsLandingPage.controllerId);
            this.logError = common.logger.getLogFn(NextStepsLandingPage.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(NextStepsLandingPage.controllerId, "success");
            this.convertedRoles = [];
            this.roles = [{ value: 1, name: "Middle School or Junior High School Student" },
            { value: 2, name: "High School Student" },
            { value: 4, name: "College or Postsecondary School Student" },
            { value: 8, name: "Adult" },
            { value: 16, name: "Parent" },
            { value: 32, name: "Education Professional" },
            { value: 64, name: "NC 529 Account Holder" },
            { value: 128, name: "Education Loan Borrower" },
            ];
            
            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.common.authentication.isLoggedIn().then(loggedIn => {
                        if (loggedIn) {
                            this.activate();
                        }
                    });
                }
            });
            
        }

        activate() {
            this.loading = true;
            var promises = [this.getProfile(), this.isTypeFormComplete(), this.getUserProgress()];
            this.common.activateController(promises, NextStepsLandingPage.controllerId)
                .then(() => {
                    this.log("Activated Next Steps Landing Page View");
                    if (!this.isEducatorRole && this.formCompleted == false) {
                        this.$location.path("/next-step");
                    }
                    this.loading = false;
            });
        }

        getUserProgress() {
            return this.Restangular.all("nextsteps").one("progress").get()
                .then(result => {
                    this.userProgress = result;
                }, (reason) => {
                    this.logError("An error occurred getting user's progress.", reason, true);
                })
        }

        getProfile() {
            return this.Restangular.one("users/profile").get()
                .then((result) => {
                    if (result) {
                        this.user = result;
                        this.getRoles();
                        this.isEducatorRole = _.some(this.convertedRoles, r => r.value == 32);
                    }
                }, (reason) => {
                    this.logError("An error occurred getting the user's profile.", reason, true);
                });
        }

        getRoles = () => {
            var userRoles = this.bitToFormValue(this.user.role);
            for (let i = 0; i < userRoles.length; i++) {
                if (userRoles[i]) {
                    this.convertedRoles.push(this.roles[i]);
                }
            }
        }



        bitToFormValue = (bit: number): any => {
            const bits = this.enumToBitValues();
            return bits.map((b) => (bit & b) === b);
        }

        enumToBitValues = (): any[] => {
            return Object.keys(Roles).map(Number).filter(Boolean)
        };
        

        isTypeFormComplete() {
            return this.Restangular.all("nextsteps").one("formcomplete").get()
                .then(result => {
                    this.formCompleted = result;
                }, err => this.logError("An error occurred getting the Nest Steps form status.", err, false));

        }

    }

    angular.module("app").controller(NextStepsLandingPage.controllerId, NextStepsLandingPage);
}